/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrokerAccountRestriction
 */
export interface BrokerAccountRestriction {
    /**
     * 
     * @type {string}
     * @memberof BrokerAccountRestriction
     */
    tradeDate: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerAccountRestriction
     */
    pId: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerAccountRestriction
     */
    aC: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerAccountRestriction
     */
    brokerId: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerAccountRestriction
     */
    restrictionCategory?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BrokerAccountRestriction
     */
    brokerRestrictions: Array<string>;
}

/**
 * Check if a given object implements the BrokerAccountRestriction interface.
 */
export function instanceOfBrokerAccountRestriction(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tradeDate" in value;
    isInstance = isInstance && "pId" in value;
    isInstance = isInstance && "aC" in value;
    isInstance = isInstance && "brokerId" in value;
    isInstance = isInstance && "brokerRestrictions" in value;

    return isInstance;
}

export function BrokerAccountRestrictionFromJSON(json: any): BrokerAccountRestriction {
    return BrokerAccountRestrictionFromJSONTyped(json, false);
}

export function BrokerAccountRestrictionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrokerAccountRestriction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tradeDate': json['trade_date'],
        'pId': json['p_id'],
        'aC': json['a_c'],
        'brokerId': json['broker_id'],
        'restrictionCategory': !exists(json, 'restriction_category') ? undefined : json['restriction_category'],
        'brokerRestrictions': json['broker_restrictions'],
    };
}

export function BrokerAccountRestrictionToJSON(value?: BrokerAccountRestriction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trade_date': value.tradeDate,
        'p_id': value.pId,
        'a_c': value.aC,
        'broker_id': value.brokerId,
        'restriction_category': value.restrictionCategory,
        'broker_restrictions': value.brokerRestrictions,
    };
}

